<template>
  <div>
    <!-- Header: Personal Info -->

    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      :opacity="0.6"
      rounded="sm"
    >
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <!-- Form: Personal Info Form -->
        <b-form class="mt-1" @submit.prevent="handleSubmit(onSubmit)">
          <!-- Field: Product ID -->
          <div>
         
              <b-form-group label="HKTV Mall Product Information Link" label-for="url">
                <div class="d-flex align-items-center">
                  <b-form-input
                    id="url"
                    v-model="temp_url"
                  />
                  <b-button
                    variant="primary"
                    class="text-nowrap ml-2"
                    :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                    @click="handleFetchURLData"
                  >
                    Get Information
                  </b-button>
                </div>
              </b-form-group>
            
          </div>

          <b-row :key="loading" v-if="is_data_fetch">
       
            <!-- <b-col cols="12" style="display: flex; justify-content: center">
              <img
                v-if="productData.image_url"
                style="width: 100%; max-width: 300px"
                :src="productData.image_url"
              />
            </b-col> -->
            <b-col cols="12" md="12">
              <b-form-group
                label="Image"
                label-for="image"
                label-cols-md="2"
              >
                <img
                    :src="productData.image"
                    style="width: 12em;"
                  />
              </b-form-group>
            </b-col>

            <b-col cols="12" md="12">
              <validation-provider #default="validationContext" name="Model">
                  <!-- rules="required" -->
                  <b-form-group label="Model">
                    <b-form-input
                      v-model="productData.model"
                      type="text"
                      placeholder="Model"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
            </b-col>

            <b-col cols="12" md="12">
              <validation-provider #default="validationContext" name="Sku">
                  <!-- rules="required" -->
                  <b-form-group label="Sku">
                    <b-form-input
                      v-model="productData.sku"
                      type="text"
                      placeholder="Sku"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
            </b-col>

            <b-col cols="12" md="6">
              <validation-provider #default="validationContext" name="Mpn">
                  <!-- rules="required" -->
                  <b-form-group label="Mpn">
                    <b-form-input
                      v-model="productData.mpn"
                      type="text"
                      placeholder="Mpn"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
            </b-col>

            <b-col cols="12" md="6">
              <validation-provider
                  #default="validationContext"
                  name="Price"
                  rules="required"
                >
                  <b-form-group class="required" label="Price">
                    <b-form-input
                      v-model="productData.price"
                      type="number"
                       step="0.0001"
                      placeholder="Price"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
            </b-col>

            <b-col cols="12" md="6">
              <validation-provider rules="required" #default="validationContext" name="Name">
                  <b-form-group class="required" label="Name">
                    <b-form-input
                      v-model="productData.name"
                      type="text"
                      placeholder="Name"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
            </b-col>
            <b-col cols="12" md="6">
              <validation-provider
                  #default="validationContext"
                  name="Short Description"
                >
                  <b-form-group label="Short Description">
                    <b-form-input
                      v-model="productData.short_description"
                      type="text"
                      placeholder="Short Description"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
            </b-col>

            <b-col cols="12" md="12">
              <b-form-group label="Description" label-for="description">
                  <quill-editor
                    id="quil-content"
                    v-model="productData.description"
                    :options="editorOption"
                    class="border-bottom-0"
                  />
                  <div
                    id="quill-toolbar-description"
                    class="d-flex justify-content-end border-top-0"
                  >
                    <!-- Add a bold button -->
                    <button class="ql-bold" />
                    <button class="ql-italic" />
                    <button class="ql-underline" />
                    <button class="ql-align" />
                    <button class="ql-link" />
                  </div>
                </b-form-group>
            </b-col>

            <b-col cols="12" md="6">
              <validation-provider
                  #default="validationContext"
                  name="Meta Title"
                >
                  <b-form-group label="Meta Title">
                    <b-form-input
                      v-model="productData.meta_title"
                      type="text"
                      placeholder="Meta Title"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
            </b-col>

            <b-col cols="12" md="6">
              <validation-provider
                  #default="validationContext"
                  name="Meta Keyword"
                >
                  <b-form-group label="Meta Keyword">
                    <b-form-input
                      v-model="productData.meta_keyword"
                      type="text"
                      placeholder="Meta Keyword"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
            </b-col>

            <b-col cols="12" md="12">
              <b-form-group
                  label="Meta Description"
                  label-for="meta_description"
                >
                  <quill-editor
                    id="quil-content"
                    v-model="productData.meta_description"
                    :options="editorOption2"
                    class="border-bottom-0"
                  />
                  <div
                    id="quill-toolbar-meta-description"
                    class="d-flex justify-content-end border-top-0"
                  >
                    <!-- Add a bold button -->
                    <button class="ql-bold" />
                    <button class="ql-italic" />
                    <button class="ql-underline" />
                    <button class="ql-align" />
                    <button class="ql-link" />
                  </div>
                </b-form-group>
            </b-col>
          </b-row>

          <!-- Button: Submit & Reset Button.-->
          <div class="mt-2">
            <template v-if="is_data_fetch">
              <b-button
                variant="primary"
                class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                type="submit"
              >
                Save
              </b-button>
              <b-button
                variant="outline-secondary"
                class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                @click="resetData"
              >
                Reset
              </b-button>
            </template>
            <b-button
              variant="outline-secondary"
              class="mr-0 mr-sm-1"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              @click="hide"
            >
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </b-overlay>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BButton,
  BFormCheckbox,
  BFormInvalidFeedback,
  BOverlay,
  BFormTextarea,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, onMounted } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, alphaNum, email } from "@validations";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";

export default {
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    flatPickr,
    BFormInput,
    vSelect,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BButton,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormInvalidFeedback,
    BOverlay,
    BFormTextarea,
    quillEditor
  },
  props: {
    productData: {
      type: Object,
      required: true,
    },
    is_data_fetch:{
      type: Boolean,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      temp_url: "",
    };
  },
  methods: {
    hide(){
      this.$router.replace("/products");
    },
    handleFetchURLData(){
      this.$emit('update:url', this.temp_url)
      this.temp_url = null
    },
    removeItem(index) {
      if (this.productData.supplier_payment_methods.length == 1) {
        this.makeToast(
          "danger",
          "Warning",
          "Please submit at least one payment method record."
        );
      } else {
        this.productData.supplier_payment_methods.splice(index - 1, 1);
      }
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title,
        variant,
        solid: true,
      });
    },
    onSubmit() {
      this.$swal({
        title: 'Are you sure?',
        showCancelButton: true,
        confirmButtonText: "Save",
        cancelButtonText: "Cancel",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$emit("update-loading-state", true);
          let formData = new FormData();
         
          formData.append("real_image_path", this.productData.image);
          formData.append("id", this.productData.id);
          formData.append("model", this.productData.model);
          formData.append("sku", this.productData.sku);
          formData.append("mpn", this.productData.mpn);
          formData.append("price", this.productData.price);
          formData.append("name", this.productData.name);
          formData.append("short_description", this.productData.short_description);
          formData.append("description", this.productData.description);
          formData.append("meta_title", this.productData.meta_title);
          formData.append("meta_keyword", this.productData.meta_keyword);
          formData.append("meta_description", this.productData.meta_description);
        
          store
            .dispatch("app-tool/addUpdateProduct", formData)
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              // this.$emit("refetch-data");
              this.$emit("reset-data");
              this.$emit("update-loading-state", false);

              // this.$router.replace("/product/list");
            })
            .catch((error) => {
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            })
            .finally(() => this.$emit("update-loading-state", false));
        }
      });
    },
  },
  setup(props, { emit }) {

    const resetData = () => {
      emit("refetch-data");
    };
    const resetuserData = () => {
      props.productData = JSON.parse(JSON.stringify({}));
    };
    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetuserData);


    const editorOption = {
      modules: {
        toolbar: "#quill-toolbar-description",
      },
      placeholder: "Description",
    };

    const editorOption2 = {
      modules: {
        toolbar: "#quill-toolbar-meta-description",
      },
      placeholder: "Meta Description",
    };

    return {
      resetData,
      refFormObserver,
      getValidationState,
      resetForm,
      resetuserData,
      editorOption,
      editorOption2
    
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.teamleader_selected {
  background: #110f6a;
  padding: 3px 8px;
  border-radius: 3px;
  color: white;
}
</style>
